export default __webpack_public_path__ + "static/vision1-d5d5d8fe58d6e188a9c8f1d8997dc395.png";